/* eslint-disable arrow-body-style */
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import {
  Button, Grid, Typography,
} from '@mui/material';

const HomeBannerDesktopTemplate = ({ banner }) => {
  return (
    <Grid
      container
      sx={{
        marginTop: '80px',
        backgroundImage: 'linear-gradient(to bottom, #E60E68, #B3004A)',
        height: 'calc(100vh - 80px)',
      }}
    >
      <Grid
        item
        xs={5}
        sx={{
          height: 'calc(100vh - 80px)',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
        }}
      >
        <img
          src={banner.image}
          alt=""
          style={{
            height: 'inherit',
            objectFit: 'contain',
            paddingLeft: '24px',
            paddingTop: '46px',
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#fff', fontSize: '40px', fontFamily: 'Poppins', fontWeight: '700',
          }}
        >
          {parse(banner.title)}
        </Typography>
        <Typography
          sx={{
            color: '#fff',
            fontSize: '32px',
            fontFamily: 'Poppins',
            fontWeight: '400',
            marginTop: '16px',
            lineHeight: '42px',
          }}
        >
          {parse(banner.description)}
        </Typography>
        <Button
          variant="contained"
          color="white"
          sx={{ marginTop: '40px', width: '352px' }}
          onClick={() => window.open(banner.link, '_blank')}
        >
          {banner.ctaLabel}
        </Button>
      </Grid>
    </Grid>
  );
};

HomeBannerDesktopTemplate.propTypes = {
  banner: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default HomeBannerDesktopTemplate;
